const sizes = {};

export default sizes;
